var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalllogs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.003,
    height: 20.481,
    viewBox: "0 0 22.003 20.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-281.388 -724)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 20,
    height: 20,
    transform: "translate(282 724)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(213.004 309.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calllogs",
    transform: "translate(68 415.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16.965,14.61l-1.173-1.173a1.5,1.5,0,0,0-2.121,0l-.922.922a.711.711,0,0,1-.784.158,12.627,12.627,0,0,1-3.833-2.649A12.645,12.645,0,0,1,5.49,8.051a.733.733,0,0,1,.162-.811l.826-.826a1.53,1.53,0,0,0,.085-2.206L5.39,3.035a2,2,0,0,0-2.828,0l-.652.651a3.194,3.194,0,0,0-.85,2.87,15.715,15.715,0,0,0,4.461,7.923,15.715,15.715,0,0,0,7.923,4.461,3.194,3.194,0,0,0,2.87-.85l.651-.651A2,2,0,0,0,16.965,14.61Z",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "up-arrow-svgrepo-com",
    transform: "matrix(0.719, 0.695, -0.695, 0.719, 81.681, 408.827)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "primary",
    y1: 7.687,
    x2: 0.121,
    transform: "translate(11.228 4.443)",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M13.587,6,11.294,3,9,6",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "up-arrow-svgrepo-com-2",
    "data-name": "up-arrow-svgrepo-com",
    transform: "matrix(-0.695, -0.719, 0.719, -0.695, 83.329, 432.51)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "primary-3",
    "data-name": "primary",
    y1: 7.687,
    x2: 0.121,
    transform: "translate(11.326 4.443)",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-4",
    "data-name": "primary",
    d: "M13.782,6,11.391,3,9,6",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalllogs);
export default __webpack_public_path__ + "static/media/calllogs.3aab24737c7145a9f3af4ad25b087458.svg";
export { ForwardRef as ReactComponent };